import { h } from 'preact';
export const LogOut = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" }),
        h("polyline", { points: "16 17 21 12 16 7" }),
        h("line", { x1: "21", y1: "12", x2: "9", y2: "12" })));
};
//# sourceMappingURL=log-out.js.map